// extracted by mini-css-extract-plugin
export default {"cls1":"qgjQzkJ6FzUzSJciLUGs","cls2":"bQllepRMRwDXbYFv0AC6 qgjQzkJ6FzUzSJciLUGs"};